import { makeStyles } from '@material-ui/styles'
import CustomStackedAreaChart from 'core/components/graphs/CustomStackedAreaChart'
import StackedAreaChartTooltip from 'core/components/graphs/StackedAreaChartTooltip'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import React from 'react'
import TimePicklist from './TimePicklist'

const TrendGraph = ({ data, onTimeRangeChange, currentTimeRange }) => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <div className={classes.headerRightContent}>
          <Text variant="subtitle2">{data?.title}</Text>
        </div>
        <div className={classes.seeAll}>
          <TimePicklist
            onChange={onTimeRangeChange}
            currentTimeRange={currentTimeRange}
            isModalView={false}
          />
          <Text variant="subtitle2">
            {data?.averageValue}&nbsp;{data?.unit}&nbsp;
          </Text>
          <Text variant="caption3">{data?.averageText || 'avg.'}</Text>
        </div>
      </div>
      <div className={classes.content}>
        <CustomStackedAreaChart
          values={data?.graph?.values}
          keys={data?.graph?.keys}
          xAxis="name"
          responsive={true}
          verticalAxisLines={!data?.graph?.values?.length}
          horizontalAxisLines={!data?.graph?.values?.length}
          responsiveHeight={120}
          showXAxisTick={true}
          dy={6}
          dx={0}
          customTooltip={
            <StackedAreaChartTooltip keys={data?.graph?.keys} yAxisPostfixLabel={data?.unit} />
          }
          xAxisTickFontSize={10}
          yAxisTickFontSize={10}
          axisLine={false}
          type="linear"
        />
      </div>
      <div className={classes.cardsRow}>
        {data?.footerValues?.map((item, index) => (
          <div key={index} className={classes.gridContainer}>
            <Text variant="caption3" className={classes.headerText}>
              {item?.key}
            </Text>
            <Text variant="caption1">{`${item?.value} ${data?.unit}`}</Text>
          </div>
        ))}
      </div>
    </div>
  )
}

export default TrendGraph

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    maxWidth: '100%',
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerRightContent: {
    display: 'flex',
    gap: theme.spacing(0.5),
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  seeAll: {
    display: 'flex',
    alignItems: 'baseline',
    gap: 0, // Ensures no space between "See All" and the icon
  },
  cardsRow: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: theme.spacing(2),
  },
  gridContainer: {
    display: 'grid',
    marginTop: theme.spacing(2),
    gap: theme.spacing(0.5),
  },
  headerText: {
    color: theme.components.card.passiveText,
  },
  content: {
    paddingTop: theme.spacing(2),
  },
}))
